import {
    ADD_TO_QUOTE_VALIDATED,
    EDIT_QUOTE,
    QUOTE_DETAILS_DRAWER_SET_VALUE,
    QUOTE_DETAILS_FORM_SET_VALID,
    QUOTE_DETAILS_FORM_SET_VALUE,
    QUOTE_DETAILS_STATE_SET_VALUE,
    REMOVE_MEMBER,
    RESET_ME_AND_MY_DIRECT_FAMILY_STATE_TRANSITION,
    SET_POPUP_MODAL_VALUE,
    SYNC_BENEFICIARY_DETAILS,
    SYNC_DIRECT_MEMBERS_COVER_AMOUNT,
    SYNC_MAIN_MEMBER_PREMIUM,
    SYNC_OTHER_MEMBERS_COVER_AMOUNT,
    SYNCH_SIZOTSA_INSURANCE_FORM_VALUES,
    SYNCH_PERSONAL_DETAILS_WITH_MAIN_MEMBER_SET_VALUE,
    UPDATE_PREMIUM_PAIDUP_ON_DOB_EDIT,
    SYNC_EXISTING_MEMBERS_DATA,
} from '../../actions/sizotsaFuneralCover/quote';
import { SF_COVER_CATEGORIES, RADIO_OPTION, RELATIONS, DEFAULT_COVER_AMOUNTS, CHILD_COVER_RATIO } from '../../actions/sizotsaFuneralCover/types';
import { calculatePremium, getMainCoverAmount } from '../../selectors/sizotsaFuneralCover/quote';
import livesCovered from '../easiplusFuneralPlan/livesCovered';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const formValuesOnCoverType = {
    formStatus: { value: FORM_STATUS.INVALID, error: null, status: null },
    relationship: { value: null, error: null, status: null },
    age: { value: null, error: null, status: null },
    dateOfBirth: { value: null, error: null, status: null },
    gender: { value: null, error: null, status: null },
    coverAmount: { value: null, error: null, status: FIELD_STATUS.VALID },
    monthlyPremium: { value: null, error: null, status: null },
    addPartner: { value: false, error: null, status: FIELD_STATUS.VALID },
    addChild: { value: false, error: null, status: FIELD_STATUS.VALID },
    selectedCoverCategory: { value: null, error: null, status: null },
    needIncomeStabilization: {
        value: null,
        error: null,
        status: null,
        dependentField: 'coverAmount',
        dependentValue: null,
        validationCondition: (currentfield, dependentField) => {
            return +dependentField?.value >= 20000
        },
    },
    incomeStabilization: {
        value: null,
        error: null,
        status: null,
    },
    benefitsDetails: { value: null, error: null, status: null },
    benefitsDetailsOnPremium: {
        value: null,
        error: null,
        status: null,
        dependentField: 'age',
        dependentValue: null,
        validationCondition: (currentfield, dependentField) => dependentField?.value < 50
    },
    title: { value: null, error: null, status: null },
    nationality: { value: 'Eswatini', error: null, status: FIELD_STATUS.VALID },
    gender: { value: null, error: null, status: null },
    id: { displayValue: null, value: null, error: null, status: null },
    firstName: { displayValue: null, value: null, error: null, status: null },
    surname: { displayValue: null, value: null, error: null, status: null },
    childIsStudent: {
        value: null,
        error: null,
        status: null,
        dependentField: 'selectedCoverCategory',
        dependentValue: RELATIONS.CHILD,
    },
    childHaveSpecialNeed: {
        value: null,
        error: null,
        status: null,
        dependentField: 'selectedCoverCategory',
        dependentValue: RELATIONS.CHILD,
    },
    memberFromLivesCovered: { value: null, error: null, status: null },
    hearAboutUs: { value: null, error: null, status: null, displayValue: null },
    hearAboutUsPlatform: {
        value: null,
        error: null,
        status: FORM_STATUS.VALID,
        dependentField: 'hearAboutUs',
        dependentValue: null,
        validationCondition: (currentfield, dependentField) =>
            ['omEmployee', 'broker'].includes(dependentField?.displayValue),
    },
    socialPlatform: {
        value: null,
        error: null,
        status: null,
        displayValue: null,
        dependentField: 'hearAboutUs',
        dependentValue: 'Online',
    },
    referFriendFamily: { value: null, error: null, status: null, displayValue: null },
    referFullName: {
        value: null,
        error: null,
        status: null,
        displayValue: null,
        dependentField: 'referFriendFamily',
        dependentValue: RADIO_OPTION.YES,
    },
    // referCountryCodeAllSure: { value: null, error: null, status: FORM_STATUS.VALID, displayValue: null },
    referCellphoneNumber: {
        value: null,
        error: null,
        status: null,
        displayValue: null,
        dependentField: 'referFriendFamily',
        dependentValue: RADIO_OPTION.YES,
    },
    email: {
        value: null,
        error: null,
        status: FIELD_STATUS.VALID,
        // dependentValue: 'msasm',
        // dependentField: 'cellphone',
        // validationCondition: (currentfield, dependentField) => dependentField.status !== FIELD_STATUS.VALID,
    },
    cellphone: {
        value: null,
        error: null,
        status: null,
        // dependentValue: 'msasm',
        // dependentField: 'email',
        // validationCondition: (currentfield, dependentField) => dependentField.status !== FIELD_STATUS.VALID,
    },

    beneficiaryName: {
        displayValue: null,
        value: null,
        error: null,
        status: null,
        dependentField: 'memberFromLivesCovered',
        dependentValue: 'Yes',
    },
    agentCode: {
        displayValue: null,
        value: null,
        error: null,
        status: null,
        dependentField: 'agentDetail',
        dependentValue: 'Yes',
    },
    agentDetail: { displayValue: null, value: null, error: null, status: null },
    currentResidence: { displayValue: null, value: null, error: null, status: null },
};

export const initQuote = {
    // covered members
    livesCovered: {
        [SF_COVER_CATEGORIES.MYSELF]: {},
        [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: {},
        [SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]: {},
        [SF_COVER_CATEGORIES.EXTENDED_FAMILY]: {},
        [SF_COVER_CATEGORIES.BENIFITS]: {},
        [SF_COVER_CATEGORIES.BENEFECIARY]: {},
        [SF_COVER_CATEGORIES.AGENT]: {},
    },
    memberId: 0,
    highestCoverAmount: 0,
    editQuoteDetails: { id: null, category: null },
    deleteQuoteDetails: null,
    form: formValuesOnCoverType,
    coverType: null,
    popupModalDetails: null,
    quotingResponse:{}
};
const getMemberId = (relation) => relation + '_' + Math.floor(10000 + Math.random() * 9999);
// const getMemberId = (relation) => relation + '_' + Math.floor(10000 + Math.random() * 9999);

export default (state = initQuote, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);

    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    const updateFormValues = (coverType) => ({
        ...state,
        form: formValuesOnCoverType,
    });
    const updateInitState = (fieldType, value) => ({
        ...state,
        form: formValuesOnCoverType,
        [fieldType]: value,
    });
    const updateStateValue = (fieldType, value) => ({
        ...state,
        [fieldType]: value,
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        // case FORM_VALID_TRANSITION_QUOTE_DETAILS:
        //     return { ...state, formStatus: FORM_STATUS.VALID };
        // case FORM_INVALID_TRANSITION_QUOTE_DETAILS:
        //     return { ...state, formStatus: FORM_STATUS.INVALID };
        case SYNCH_SIZOTSA_INSURANCE_FORM_VALUES:
            return updateFormValues(action.value);

        case SYNC_BENEFICIARY_DETAILS:
            const { [action?.value]: slectedMemeberDetails = formValuesOnCoverType } = {
                ...state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
                ...state.livesCovered[SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
                ...state.livesCovered[SF_COVER_CATEGORIES.EXTENDED_FAMILY]
            };
            const beneficiaryName = {
                beneficiaryName: action?.value ? state.form.beneficiaryName : formValuesOnCoverType.beneficiaryName,
                email: action?.value ? state.form.email : formValuesOnCoverType.email,
                cellphone: action?.value ? state.form.cellphone : formValuesOnCoverType.cellphone
                // memberFromLivesCovered: action?.value ? state.form.memberFromLivesCovered : formValuesOnCoverType.memberFromLivesCovered,
            };
            return {
                ...state,
                form: {
                    ...slectedMemeberDetails,
                    ...beneficiaryName,
                    // email:state.form.email,
                    // cellphone:state.form.cellphone,
                    id: {
                        ...slectedMemeberDetails.id,
                        status: slectedMemeberDetails.id.value ? slectedMemeberDetails.id.status : null
                    },
                    selectedCoverCategory: {
                        ...slectedMemeberDetails.selectedCoverCategory,
                        value: SF_COVER_CATEGORIES.BENEFECIARY
                    },
                    memberFromLivesCovered: state.form.memberFromLivesCovered
                }
            };

        case QUOTE_DETAILS_FORM_SET_VALUE:
            return updateFormField(action.value.fieldType, field => ({
                ...field,
                displayValue: action.value.displayValue ?? action.value.value,
                value: action.value.value
            }));

        case QUOTE_DETAILS_FORM_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, field => ({
                ...field,
                error: error,
                status: mapError(error)
            }));

        case REMOVE_MEMBER:
            const { id, category } = action.value;
            const isBeneficiary =
                Object.values(state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY])[0]?.beneficiaryName?.value === id;
            const { [id]: deletedMember, ...modifiedLivesCovered } = state.livesCovered[category];
            return {
                ...state,
                livesCovered: {
                    ...state.livesCovered,
                    [SF_COVER_CATEGORIES.BENEFECIARY]: isBeneficiary
                        ? {}
                        : state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY],
                    [category]: modifiedLivesCovered
                }
            };

        case EDIT_QUOTE:
            return {
                ...state,
                form: state.livesCovered[action.value.category][action.value.id],
                editQuoteDetails: {
                    category: action.value.category,
                    id: action.value.id,
                    relation: state.livesCovered[action.value.category][action.value.id]?.relationship?.value
                },
                coverType: action.value.coverType
            };

        case ADD_TO_QUOTE_VALIDATED:
            const { coverType, relation } = action.value;
            let targetObject = state.livesCovered;
            let updatedId = state.memberId + 1;
            let userId = 'member_' + state.memberId;
            const sourceObject = {
                [state.editQuoteDetails?.id || userId]: {
                    ...state.form,
                    relationship: { ...state.form.relationship, value: relation, status: FIELD_STATUS.VALID }
                }
            };
            Object.assign(targetObject[coverType], sourceObject);
            return {
                ...state,
                form: formValuesOnCoverType,
                livesCovered: { ...targetObject },
                coverType: null,
                editQuoteDetails: { id: null, category: null },
                memberId: state.editQuoteDetails?.id ? state.memberId : updatedId
            };

        case QUOTE_DETAILS_DRAWER_SET_VALUE:
            return updateInitState(action.value?.fieldType, action.value?.value);

        case QUOTE_DETAILS_STATE_SET_VALUE:
            return updateStateValue(action.value?.fieldType, action.value?.value);

        case SYNC_OTHER_MEMBERS_COVER_AMOUNT:
            const performSync = productCode => {
                Object.keys(state.livesCovered[productCode])?.map(memberId => {
                    const selectedMember = state.livesCovered[productCode][memberId];
                    const coverAmountForSelectedMember =
                        selectedMember.age.value >= 60 ? 5000 : selectedMember.coverAmount?.value;
                    selectedMember.coverAmount.value = coverAmountForSelectedMember;
                    // console.log(mainMemberCoverAmount);
                    // console.log(coverAmountForSelectedMember);
                    selectedMember.monthlyPremium.value = calculatePremium(
                        productCode,
                        selectedMember.age.value,
                        coverAmountForSelectedMember
                    );
                    Object.assign(state.livesCovered[productCode], { [memberId]: selectedMember });
                });
            };
            performSync(SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS);
            performSync(SF_COVER_CATEGORIES.EXTENDED_FAMILY);
            return { ...state, highestCoverAmount: 5000, livesCovered: { ...state.livesCovered } };

        case SYNC_MAIN_MEMBER_PREMIUM:
            const mainMemberKey = Object.keys(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])[0];
            const mainMember = state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY][mainMemberKey];
            const productCategory =
                Object.values(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]).length > 1
                    ? SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
                    : SF_COVER_CATEGORIES.MYSELF;
            mainMember.monthlyPremium.value = calculatePremium(
                productCategory,
                mainMember.age.value ,
                mainMember.coverAmount.value,
              mainMember.needIncomeStabilization.value === 'Yes' ?  mainMember.incomeStabilization.value : null
            );
            Object.assign(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY], {
                [mainMemberKey]: mainMember
            });
            return {
                ...state,
                livesCovered: { ...state.livesCovered }
            };
        case SYNC_DIRECT_MEMBERS_COVER_AMOUNT:
            // console.log(action.value);
            const syncCoverAmounts = () => {
                Object.keys(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])?.map(memberId => {
                    const selectedMember = state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY][memberId];
                    const childCoverAmount = (
                        CHILD_COVER_RATIO.filter(
                            ({ minAge, maxAge }) =>
                                selectedMember.age.value >= minAge && selectedMember.age.value < maxAge
                        )[0]?.percent * action.value
                    )?.toFixed(2);
                    let amount = selectedMember.relationship.value === 'Child' ? childCoverAmount : action.value;
                    selectedMember.coverAmount = { value: amount, error: null, status: FIELD_STATUS.VALID };
                    Object.assign(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY], {
                        [memberId]: selectedMember
                    });
                });
                return;
            };
            syncCoverAmounts();
            return {
                ...state,
                livesCovered: { ...state.livesCovered }
            };
        case SYNCH_PERSONAL_DETAILS_WITH_MAIN_MEMBER_SET_VALUE:
            const mainMemberDetails = Object.keys(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY])[0];
            const { title, firstName, surname, nationality, id: bwId } = action.value;
            return {
                ...state,
                livesCovered: {
                    ...state.livesCovered,
                    [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: {
                        ...state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
                        [mainMemberDetails]: {
                            ...state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY][mainMemberDetails],
                            title: { ...title },
                            nationality: { ...nationality },
                            firstName: { ...firstName },
                            surname: { ...surname },
                            id: { ...bwId },
                            formStatus: {
                                value: FORM_STATUS.VALID,
                                error: null,
                                status: null,
                                displayValue: FORM_STATUS.VALID
                            }
                        }
                    }
                }
            };
        case RESET_ME_AND_MY_DIRECT_FAMILY_STATE_TRANSITION:
            return {
                ...state,
                livesCovered: { ...state.livesCovered, [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: {} }
            };
        case SET_POPUP_MODAL_VALUE:
            return {
                ...state,
                popupModalDetails: action.value
            };

        case SYNC_EXISTING_MEMBERS_DATA:
            const { [action?.value ?? '']: selectedBeneficiary = formValuesOnCoverType } = {
                ...state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY],
                ...state.livesCovered[SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS],
                ...state.livesCovered[SF_COVER_CATEGORIES.EXTENDED_FAMILY]
            };
            const currentBeneficiaryKey = Object.keys(state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY])[0];
            const existingBeneficiary =
              action?.value?  selectedBeneficiary : state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY][currentBeneficiaryKey];
            const memberFromLivesCoveredKey = action?.value
                ? currentBeneficiaryKey
                : state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY][currentBeneficiaryKey].beneficiaryName.value;

            const memberCategory = (() => {
                if (
                    Object.keys(state.livesCovered[SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]).includes(
                        memberFromLivesCoveredKey
                    )
                ) {
                    return SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY;
                } else if (
                    Object.keys(state.livesCovered[SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]).includes(
                        memberFromLivesCoveredKey
                    )
                ) {
                    return SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS;
                } else if (
                    Object.keys(state.livesCovered[SF_COVER_CATEGORIES.EXTENDED_FAMILY]).includes(
                        memberFromLivesCoveredKey
                    )
                ) {
                    return SF_COVER_CATEGORIES.EXTENDED_FAMILY;
                }
                 else if (
                    Object.keys(state.livesCovered[SF_COVER_CATEGORIES.BENEFECIARY]).includes(
                        memberFromLivesCoveredKey
                    )
                ) {
                    return SF_COVER_CATEGORIES.BENEFECIARY;
                } else return null;
            })();
            // selectedBeneficiary;
            // const
            return {
                ...state,
                ...(memberCategory
                    ? {
                          livesCovered: {
                              ...state.livesCovered,
                              [memberCategory]: {
                                  ...state.livesCovered[memberCategory],
                                  [memberFromLivesCoveredKey]: existingBeneficiary
                              }
                          }
                      }
                    : {})
            };
        case UPDATE_PREMIUM_PAIDUP_ON_DOB_EDIT:
            const benfitKey = Object.keys(state.livesCovered[SF_COVER_CATEGORIES.BENIFITS])[0];
            const updatedbenefits = {
                ...Object.values(state.livesCovered[SF_COVER_CATEGORIES.BENIFITS])[0],
                incomeStabilization: {
                    value: null,
                    error: null,
                    status: null
                }
            };
            return {
                ...state,
                livesCovered: {
                    ...state.livesCovered,
                    [SF_COVER_CATEGORIES.BENIFITS]: {
                        [benfitKey]: { ...updatedbenefits }
                    }
                }
            };
        default:
            return state;
        // }
    }
};
